import "../base.js";
import "../mixins/conditional_visibility.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};

AppointmentBooking.Wizard.Views.Header.MainMenuExpander = class MainMenuExpander extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(AppointmentBooking.Wizard.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.model, "change:mainMenuExpanded", this.render);
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.$el.toggleClass("active", this.model.get("mainMenuExpanded"));

    return this;
  }

  // PRIVATE

  toggleExpander() {
    return this.model.set("mainMenuExpanded", !this.model.get("mainMenuExpanded"));
  }
};
AppointmentBooking.Wizard.Views.Header.MainMenuExpander.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Header.MainMenuExpander.prototype.template = false;
AppointmentBooking.Wizard.Views.Header.MainMenuExpander.prototype.className =
  "appointment-booking-wizard-main-menu-expander";
AppointmentBooking.Wizard.Views.Header.MainMenuExpander.prototype.events = { click: "toggleExpander" };
